import React, { useState } from "react";
import { Alert, InputContainer } from "@networkraildigitalfactory/components";
import Toggle from "react-toggle";
import styles from "./CreateReviewPrep.module.css";
import CollapsibleObjectiveDetails from "../CollapsibleObjectiveDetails/CollapsibleObjectiveDetails";
import "react-toggle/style.css";

const ObjectiveInput = (props) => {
  const {
    objective,
    error,
    inputRef,
    onChange,
    onKeyDown,
    reviewType,
    defaultValue,
    interimReviewComment,
    canRemove,
    isNewObjective,
    isGBREmployee,
  } = props;
  const { _id } = objective;
  const [isMandatory, setIsMandatory] = useState(!isNewObjective);
  return (
    <>
      <CollapsibleObjectiveDetails
        objectiveDetails={objective}
        isGBREmployee={isGBREmployee}
        isOpen={false}
      />
      {canRemove && reviewType === "EOY" && (
        <div className={styles.toggle}>
          <Toggle
            defaultChecked={isMandatory}
            className={styles.objective_switch}
            onChange={() => {
              setIsMandatory(!isMandatory);
            }}
          />
          <span className={styles.toggle_label}> Include in this EOY review</span>
        </div>
      )}
      {reviewType === "EOY" && interimReviewComment && (
        <Alert
          color="blue"
          title="Interim review comment"
          message={interimReviewComment}
          style={{
            margin: "24px 0",
          }}
        />
      )}
      {isMandatory || reviewType !== "EOY" ? (
        <InputContainer
          labelText={`${reviewType === "EOY" ? "Overall p" : "P"}rogress on this objective`}
          forLabel={`objective${_id}`}
          required
          errorText={error && error.message}
        >
          <textarea
            id={`objective${_id}`}
            className={error ? styles.error : ""}
            name={`objective${_id}`}
            ref={inputRef}
            onChange={onChange}
            defaultValue={defaultValue}
            onKeyDown={(e) => onKeyDown(e, `objective${_id}`)}
          />
        </InputContainer>
      ) : (
        <div
          style={{
            padding: "20px",
            margin: "24px 0",
            background: "#e7e7e7",
            borderRadius: 10,
          }}
        >
          This objective is not included in this EOY review.
        </div>
      )}
    </>
  );
};

export default ObjectiveInput;
